/**
 * Packages & Services builder — shared helpers. Extracted verbatim
 * from the former AgencyServicesPage monolith (Task 150-A). No behavior
 * change.
 */

import { isApiError, KmiApiError } from '../../api/client';

export function billingIntervalLabel(interval: string | null): string {
  switch (interval) {
    case 'one_time':
      return 'مرّة واحدة';
    case 'monthly':
      return 'شهري';
    case 'quarterly':
      return 'ربع سنوي';
    case 'yearly':
      return 'سنوي';
    case 'custom':
      return 'مخصّص';
    default:
      return '—';
  }
}

export function handleApiErr(err: unknown, setError: (v: string | null) => void): void {
  if (err instanceof KmiApiError) {
    if (err.code === 'conflict') {
      setError('السجل موجود بالفعل (الاسم مستخدم).');
      return;
    }
    if (err.code === 'permission_denied') {
      setError('لا تملك صلاحية تنفيذ هذه العملية.');
      return;
    }
    if (err.code === 'validation_error') {
      setError('البيانات غير صالحة. تأكد من الحقول وحاول مجدداً.');
      return;
    }
  }
  if (isApiError(err)) {
    setError('تعذّر إكمال العملية. حاول مجدداً.');
    return;
  }
  setError('تعذّر إكمال العملية. حاول مجدداً.');
}
